import { ChevronRight } from 'lucide-react'
import type { BreadcrumbSegment } from '@/shared/hooks/use-breadcrumbs'

interface BreadcrumbProps {
  segments: BreadcrumbSegment[]
}

export function Breadcrumb({ segments }: BreadcrumbProps) {
  if (segments.length === 0) return null

  return (
    <nav aria-label="Breadcrumb" className="flex items-center gap-1 text-xs min-w-0">
      {segments.map((segment, index) => {
        const isLast = index === segments.length - 1

        return (
          <span key={index} className="flex items-center gap-1 min-w-0">
            {index > 0 && (
              <ChevronRight className="h-3 w-3 shrink-0 text-toolbar-muted/60" />
            )}
            {isLast ? (
              <span className="text-toolbar-foreground font-medium truncate">
                {segment.label}
              </span>
            ) : (
              <span className="text-toolbar-muted truncate">{segment.label}</span>
            )}
          </span>
        )
      })}
    </nav>
  )
}
